const useSimpleStep = ({
  saveAnswer,
  upsertDerivedAnswer,
  dispatch,
  setAgentData,
  agentData,
  getAnswersMap,
  isExistingUser,
  requestRegistration,
  goToNextStep,
}) => {
  const handleSimpleStep = async (
    step,
    answerText,
    photoUrl = null,
  ) => {
    saveAnswer({
      step,
      text: answerText,
      photoUrl,
      extractedValue: answerText,
      value: answerText,
      isValid: true,
      attempt: 1,
    })

    if (step.id === 'hair_prediction_corrected_value') {
      upsertDerivedAnswer('correctedHairClass', answerText)
      upsertDerivedAnswer('predictedHairClass', answerText)
      upsertDerivedAnswer('hairPrediction', {
        predictedHairClass: answerText,
        predictedHairDescription: `Selected hair class ${answerText}`,
      })
      upsertDerivedAnswer('isPredictedHairClassCorrect', 'No')
    }

    if (step.id === 'store_owner') {
      const status = answerText === 'Yes' ? 'Store Owner' : 'User'

      dispatch(setAgentData({
        ...agentData,
        status,
      }))
    }

    if (step.id === 'contact_source') {
      const answersMap = getAnswersMap()

      if (
        answersMap.storeOwner &&
        answersMap.referralSource &&
        answersMap.contactSource &&
        !isExistingUser
      ) {
        requestRegistration()
      }
    }

    goToNextStep(step.id)
  }

  return {
    handleSimpleStep,
  }
}

export default useSimpleStep